import { EQP_LIST } from "./constants";

export function buildRegiPayload(row, { dsid, seqnum }) {
  const tdsort = String(row.eqp ?? "").trim();
  const esort = EQP_LIST.includes(tdsort) ? "소방" + tdsort : tdsort;

  return {
    datakind: "new",
    seqnum,
    dsid: String(dsid || "").trim(),
    rgid: "",
    sort: esort,
    pnum: String(row.pnum ?? "").trim(),
    org: String(row.sido ?? "").trim(),
    name: String(row.name ?? "").trim(),
    callsgn: String(row.callsgn ?? "").trim(),
    sumnum: String(row.sumnum ?? "").trim(),
    rdvs: String(row.rdvs ?? "").trim(),
    cntct: String(row.cntct ?? "").trim(),
  };
}

export function validateReplyNumber(replyNumber) {
  const v = String(replyNumber ?? "").trim();
  if (!v) return { ok: false, message: "회신번호를 입력해주세요." };
  if (!/^[\d-]{12,13}$/.test(v)) {
    return {
      ok: false,
      message: "올바른 회신번호 형식이 아닙니다.\n예시: 033-249-5664",
    };
  }
  return { ok: true, value: v };
}
